// App
const sidebarStatusKey = 'sidebar_status'
export const getSidebarStatus = () => localStorage.getItem(sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) => localStorage.setItem(sidebarStatusKey, sidebarStatus)

// User
const tokenKey = 'leaky_hunter_token'
export const getToken = (): string => localStorage.getItem(tokenKey) || ''
export const setToken = (token: string) => localStorage.setItem(tokenKey, token)
export const removeToken = () => localStorage.removeItem(tokenKey)

// 记住账号密码
const rememberMeKey = 'remember_me'
const usernameKey = 'remembered_username'
const passwordKey = 'remembered_password'

export const getRememberMe = (): boolean => localStorage.getItem(rememberMeKey) === 'true'
export const setRememberMe = (remember: boolean) => localStorage.setItem(rememberMeKey, remember.toString())
export const removeRememberMe = () => localStorage.removeItem(rememberMeKey)

export const getRememberedUsername = (): string => localStorage.getItem(usernameKey) || ''
export const setRememberedUsername = (username: string) => localStorage.setItem(usernameKey, username)
export const removeRememberedUsername = () => localStorage.removeItem(usernameKey)

export const getRememberedPassword = (): string => {
  const pwd = localStorage.getItem(passwordKey)
  return pwd ? window.atob(pwd) : '' // 使用base64解码存储的密码
}
export const setRememberedPassword = (password: string) => {
  localStorage.setItem(passwordKey, window.btoa(password)) // 使用base64编码密码
}
export const removeRememberedPassword = () => localStorage.removeItem(passwordKey)

// Permission
const permissionKey = 'leaky_hunter_permission'
export const getPermissions = (): string[] => {
  const permissionStr = localStorage.getItem(permissionKey)
  return permissionStr ? permissionStr.split(',') : []
}
export const setPermission = (permissions: string[]) => {
  localStorage.setItem(permissionKey, permissions.join(','))
}
export const removePermission = () => localStorage.removeItem(permissionKey)

// Org
const orgKey = 'leaky_hunter_org'
export const getCurrentOrg = (): number => {
  const orgStr = localStorage.getItem(orgKey)
  return orgStr ? parseInt(orgStr) : -1
}
export const setCurrentOrg = (orgId: number) => {
  localStorage.setItem(orgKey, orgId.toString())
}
export const removeCurrentOrg = () => localStorage.removeItem(orgKey)
